import React, { useEffect } from 'react';
import { CiLock } from "react-icons/ci";
import { FaUserGear } from "react-icons/fa6";
import { BsBrowserFirefox } from "react-icons/bs";

import { MdOutlineDesignServices } from "react-icons/md";
import { GrCloudComputer } from "react-icons/gr";
import { GiMechanicalArm } from "react-icons/gi";
import { RxDrawingPinFilled } from "react-icons/rx";
import { LuComputer } from "react-icons/lu";
import { MdArchitecture } from "react-icons/md";
import { MdElectricBolt } from "react-icons/md";
import { GiMechanicGarage } from "react-icons/gi";
import { FaBuildingUser } from "react-icons/fa6";
import { GiElectricalResistance } from "react-icons/gi";
import { RiComputerLine } from "react-icons/ri";
import { FaGooglePlay } from "react-icons/fa";
import {Link} from 'react-router-dom'

import Review from "../Pages/Review";


import Slider from "./Slider";
import TabItem from "../Pages/TabItem";

const Homeslider = () => {

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      // loop over all the entries
      entries.forEach((entry) => {
        console.log(entry);
        // use a conditional to check if the entry is intersection
        if (entry.isIntersecting) {
          // add show class
          entry.target.classList.add("show");
        } else {
          // remove when not intersecting
          entry.target.classList.remove("show");
        }
      });
    });
    
    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((el) => observer.observe(el));    
  })

  return (
    <>
      <Slider />

    

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-0cb3929 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="0cb3929"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-69b152e"
            data-id="69b152e"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-3da82cc elementor-widget elementor-widget-ontech-service"
                data-id="3da82cc"
                data-element_type="widget"
                data-widget_type="ontech-service.default"
              >
                <div class="elementor-widget-container">
                  <section class="intro-one responsive_home_card hidden">
                    <div class="shape2">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/intro-v1-shape2.png"
                        alt="alt"
                        title="intro-v1-shape2"
                      />{" "}
                    </div>
                    <div class="container">
                      <div class="row">
                        <div
                          class="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp first_try"
                          data-wow-delay="0.1s"
                        >
                          <Link to="/Courses#MECH" className="link" >

                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src="/images/cad shaw civil10.jpg"
                                  alt="alt"
                                  title="intro-v1-img1"
                                />{" "}
                              </div>
                              <div class="icon-box">
                                <FaUserGear style={{ fontSize: "37px" }} />
                              </div>
                            </div>

                            <div class="intro-one__single-content text-center">
                              <div class="shape1">
                                <img
                                  decoding="async"
                                  src="https://images.pexels.com/photos/159298/gears-cogs-machine-machinery-159298.jpeg?auto=compress&cs=tinysrgb&w=600"
                                  alt="alt"
                                  title="intro-v1-shape1"
                                />{" "}
                              </div>
                              <h2>
                                <a class="" href="/Courses">
                                  Mechanical Courses
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "16px" }}>
                               
The theoretical and practical aspects of machinery and systems solve complex problems through  efficient implementation.
                              </p>
                            </div>
                          </div>
                           
                          </Link>
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp first_try"
                          data-wow-delay="0.2s"
                        >
                          <Link to="/Courses#CIVI" className="link">
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src=" /images/mechanical1.png"
                                  alt="alt"
                                  title="intro-v1-img2"
                                />{" "}
                              </div>
                              <div className="icon-box">
                                <MdArchitecture style={{ fontSize: "37px" }} />
                              </div>
                            </div>

                            <div class="intro-one__single-content text-center">
                              <div class="shape1">
                                <img
                                  decoding="async"
                                  src="https://images.pexels.com/photos/1668921/pexels-photo-1668921.jpeg?auto=compress&cs=tinysrgb&w=600"
                                  alt="alt"
                                  title="intro-v1-shape1"
                                />{" "}
                              </div>
                              <h2>
                                <a class=" " href="/Courses">
                                  Civil Courses
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "16px" }}>
                                Focuses on designing, constructing, and
                                maintaining infrastructure enhance societal
                                well-being development.
                              </p>
                            </div>
                          </div>
                          </Link>

                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp first_try"
                          data-wow-delay="0.3s"
                        >
                           <Link to="/Courses#ELEC" className="link" >
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src=" /images/shawelectric.png"
                                  alt="alt"
                                  title="intro-v1-img3"
                                />{" "}
                              </div>
                              <div class="icon-box">
                                <MdElectricBolt style={{ fontSize: "37px" }} />
                              </div>
                            </div>

                            <div class="intro-one__single-content text-center">
                              <div class="shape1">
                                <img
                                  decoding="async"
                                  src="https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=600"
                                  alt="alt"
                                  title="intro-v1-shape1"
                                />{" "}
                              </div>
                              <h2>
                                <a class="  " href="/Courses">
                                  Electrical Courses
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "16px" }}>
                                Involves the study of electrical systems,
                                electronics,such as power systems, circuits, and
                                communication networks.
                              </p>
                            </div>
                          </div>
                          </Link>
                        </div>


                        

                        <div
                          class="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp first_try"
                          data-wow-delay="0.3s"
                        >
                          <Link to="/Courses#COMP" className="link" >
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src="/images/civil.png"
                                  alt="alt"
                                  title="intro-v1-img3"
                                />{" "}
                              </div>
                              <div class="icon-box">
                                <BsBrowserFirefox
                                  style={{ fontSize: "37px" }}
                                />
                              </div>
                            </div>

                            <div class="intro-one__single-content text-center">
                              <div class="shape1">
                                <img
                                  decoding="async"
                                  src="https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=600"
                                  alt="alt"
                                  title="intro-v1-shape1"
                                />{" "}
                              </div>
                              <h2>
                                <a class="  " href="/Courses">
                                  Computer Courses
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "16px" }}>
                                Theoretical and practical aspects of computing,
                                design to create innovative solutions and
                                advance technology.
                              </p>
                            </div>
                          </div>
                          </Link>
                        </div>

                        <div
                          class="col-xl-5 col-lg-5 col-md-6 wow animated fadeInUp first_try"
                          data-wow-delay="0.3s"
                        >
                          
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp first_try"
                          data-wow-delay="0.3s"
                        >
                           <Link to="/Courses#PROF" className="link" >
                          <div class="intro-one__single">
                            <div class="intro-one__single-img">
                              <div class="inner">
                                <img
                                  decoding="async"
                                  src=" /images/shawelectric.png"
                                  alt="alt"
                                  title="intro-v1-img3"
                                />{" "}
                              </div>
                              <div class="icon-box">
                                <MdElectricBolt style={{ fontSize: "37px" }} />
                              </div>
                            </div>

                            <div class="intro-one__single-content text-center">
                              <div class="shape1">
                                <img
                                  decoding="async"
                                  src="https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=600"
                                  alt="alt"
                                  title="intro-v1-shape1"
                                />{" "}
                              </div>
                              <h2>
                                <a class="  " href="/Courses">
                             Prof Courses
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "16px" }}>
                                Involves the study of electrical systems,
                                electronics,such as power systems, circuits, and
                                communication networks.
                              </p>
                            </div>
                          </div>
                          </Link>
                        </div>
                        {/* <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp first_try" data-wow-delay="0.3s">
    <Link to="/specializations#ELECTRICAL" className="link">
      <div className="intro-one__single">
        <div className="intro-one__single-img">
          <div className="inner">
            <img
              decoding="async"
              src="/images/shawelectric.png"
              alt="Electrical course"
              title="intro-v1-img3"
            />
          </div>
          <div className="icon-box">
            <MdElectricBolt style={{ fontSize: "37px" }} />
          </div>
        </div>
        <div className="intro-one__single-content text-center">
          <div className="shape1">
            <img
              decoding="async"
              src="https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=600"
              alt="Shape"
              title="intro-v1-shape1"
            />
          </div>
          <h2>Prof Courses</h2>
          <p style={{ fontSize: "16px" }}>
            Involves the study of electrical systems, electronics, such as power systems, circuits, and communication networks.
          </p>
        </div>
      </div>
    </Link>
  </div> */}

                      </div>
                    </div>


                    
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-1650b86 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="1650b86"
        data-element_type="section"
        style={{ marginBottom: "-30px" }}
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e578a6b"
            data-id="e578a6b"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-eaf424a elementor-widget elementor-widget-ontech-about"
                data-id="eaf424a"
                data-element_type="widget"
                data-widget_type="ontech-about.default"
              >
                <div class="elementor-widget-container">
                  <section class="about-one responsive_home_card hidden">
                    {/* <div class="shape5 rotate-me">
                      <img
                        decoding="async"
                        src=""
                        alt="alt"
                        title="about-v1-shape4"
                      />{" "}
                    </div> */}
                    <div class="shape6">
                      <img
                        decoding="async"
                        src=""
                        alt="alt"
                        title="about-v1-shape5"
                      />{" "}
                    </div>
                    <div class="container">
                      <div class="row">
                        <div class="col-xl-6">
                          <div class="about-one__content">
                            <div class="sec-title">
                              <div class="sec-title__tagline">
                                <div class="inner">
                                  <div class="round-box">
                                    <img
                                      decoding="async"
                                      src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/sec-title-shape.png"
                                      alt="alt"
                                      title="sec-title-shape"
                                    />{" "}
                                  </div>
                                  <div class="text">
                                    <p class="sec-title__sub-title">About Us</p>
                                  </div>
                                </div>
                              </div>
                              <h2 class="sec-title__title">
                                We Specialize In Design Solutions
                              </h2>
                            </div>

                            <div class="about-one__content-text1">
                              <p class="summary" style={{textAlign:"justify"}}>
                                We are glad to introduce 1st exclusive CAD/CAM
                                Training Institute along with CNC Training
                                facility with Virtual Machines (Fanuc Oi series
                                controller) of North Odisha. We are offering
                                this training program to the engineering
                                students and professions in the field of
                                Designing along with the CAD/CAM software’s for
                                CIVIL & MECHANICAL branch. Program is based on
                                latest technologies to develop the students such
                                a way they can be efficient and update according
                                to the demand of industries.
                              </p>
                              <h2 class="highlighted-text">
                                Ready To Transform Your Design
                              </h2>
                            </div>

                            <div class="about-one__content-text2">
                              <div class="row">
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                  <div class="about-one__content-text2-single">
                                    <div class="icon-box">
                                      <MdOutlineDesignServices
                                        style={{ fontSize: "40px" }}
                                        className="floating_icon"
                                      />
                                      <div
                                        class="shape1"
                                        style={{
                                          backgroundColor: "#FFB237",
                                        }}
                                      ></div>
                                    </div>

                                    <div class="content-box">
                                      <h3>
                                        <b>Design Solution</b></h3>
                                      <p style={{ fontSize: "18px" }}>
                                        Crafting innovative and user-centric
                                        design solutions that seamlessly blend
                                        form and function for an enhanced user
                                        experience.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6">
                                  <div class="about-one__content-text2-single">
                                    <div class="icon-box">
                                      <GrCloudComputer
                                        style={{ fontSize: "40px" }}
                                        className="floating_icon"
                                      />
                                      <div
                                        class="shape1"
                                        style={{
                                          backgroundColor: "#FFB237",
                                        }}
                                      ></div>
                                    </div>

                                    <div class="content-box">
                                      <h3>
                                        <b>Computer Knowledge</b></h3>
                                      <p style={{ fontSize: "18px" }}>
                                        Empowering digital evolution through
                                        cutting-edge technology and
                                        computational prowess.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-xl-6">
                          <div class="about-one__img">
                            <div class="about-one__img1">
                              <img
                                decoding="async"
                                src="/images/cad shaw civil5.png"
                                alt="alt"
                                title="about-v1-img1"
                              />{" "}
                            </div>

                            <div class="about-one__img2">
                              <div class="shape4 rotate-me">
                                <svg xmlns="http://www.w3.org/2000/svg" width="6rem" height="10rem" viewBox="0 0 56 56"><path fill="#FFB237" d="M28 50.828c.61 0 1.172-.07 1.805-.117l1.36 2.578c.257.516.773.797 1.405.703c.586-.117 1.008-.539 1.078-1.172l.422-2.836c1.149-.304 2.297-.75 3.422-1.242l2.11 1.899c.445.422 1.007.515 1.593.187c.516-.281.727-.844.61-1.453l-.586-2.812a21.53 21.53 0 0 0 2.789-2.32l2.625 1.1c.586.235 1.125.118 1.57-.421c.399-.422.445-1.031.117-1.547l-1.523-2.437c.703-.985 1.266-2.04 1.805-3.165l2.86.141c.608.023 1.124-.305 1.335-.89c.187-.587 0-1.149-.492-1.524l-2.227-1.781c.305-1.125.54-2.344.633-3.61l2.719-.843c.586-.211.96-.657.96-1.29c0-.609-.374-1.054-.96-1.265l-2.72-.867c-.093-1.266-.327-2.438-.632-3.586l2.226-1.805c.493-.351.68-.89.493-1.476c-.211-.586-.727-.915-1.336-.891l-2.86.117c-.538-1.125-1.1-2.18-1.804-3.164l1.524-2.437c.327-.493.28-1.102-.118-1.524c-.445-.539-.984-.68-1.57-.422l-2.625 1.055a25.884 25.884 0 0 0-2.79-2.297l.587-2.789c.117-.633-.094-1.195-.61-1.477c-.586-.304-1.148-.257-1.593.211l-2.11 1.852a27.105 27.105 0 0 0-3.422-1.219l-.422-2.836c-.07-.61-.492-1.054-1.078-1.148c-.633-.094-1.148.164-1.406.68l-1.36 2.578c-.632-.047-1.195-.094-1.804-.094c-.633 0-1.195.047-1.852.094l-1.335-2.578c-.258-.516-.774-.774-1.43-.68c-.586.094-.985.539-1.078 1.148l-.399 2.813a28.27 28.27 0 0 0-3.422 1.242l-2.109-1.852c-.469-.468-1.031-.515-1.594-.21c-.515.28-.726.843-.61 1.476l.587 2.79a24.044 24.044 0 0 0-2.813 2.296l-2.601-1.055c-.586-.258-1.149-.117-1.594.422a1.235 1.235 0 0 0-.117 1.5L9.18 15.04c-.703.984-1.266 2.04-1.805 3.164l-2.883-.117c-.61-.023-1.125.305-1.312.89c-.188.587-.024 1.126.468 1.477l2.25 1.805c-.304 1.148-.562 2.32-.632 3.586l-2.72.867c-.608.187-.937.633-.937 1.266c0 .632.329 1.078.938 1.289l2.719.867c.07 1.242.328 2.46.633 3.586l-2.25 1.78c-.493.375-.657.938-.47 1.523c.188.586.704.914 1.313.891l2.883-.14c.54 1.124 1.102 2.18 1.781 3.163l-1.5 2.438c-.351.516-.304 1.125.094 1.547c.445.539 1.008.656 1.594.422l2.601-1.102c.868.867 1.829 1.64 2.813 2.32l-.586 2.813c-.117.61.094 1.172.61 1.453c.585.328 1.148.234 1.593-.187l2.086-1.899c1.125.492 2.273.938 3.445 1.242l.399 2.836c.093.633.492 1.055 1.078 1.172c.656.094 1.172-.187 1.43-.703l1.335-2.578c.633.047 1.22.117 1.852.117M33.883 26.5c-1.102-2.953-3.258-4.57-5.953-4.57c-.399 0-.867.047-1.617.21l-6.727-11.484C22.094 9.414 24.953 8.734 28 8.734c10.219 0 18.234 7.758 18.961 17.766ZM8.969 28c0-6.516 3.07-12.258 7.922-15.726l6.773 11.554c-1.266 1.313-1.851 2.742-1.851 4.266c0 1.476.562 2.836 1.851 4.195l-6.937 11.344C11.992 40.14 8.969 34.469 8.969 28m16.148.07c0-1.593 1.36-2.836 2.86-2.836c1.593 0 2.906 1.243 2.906 2.836c0 1.57-1.313 2.86-2.906 2.86c-1.5 0-2.86-1.29-2.86-2.86M28 47.266c-3.117 0-6.023-.727-8.578-1.992L26.312 34c.727.188 1.22.234 1.618.234c2.718 0 4.875-1.664 5.953-4.687H46.96c-.75 9.96-8.766 17.719-18.961 17.719"/></svg>
                              </div>
                              <ul class="ml-0">
                                <li>
                                  <div class="img-box1">
                                    <img
                                      decoding="async"
                                      src="/images/mechanical2.png"
                                      alt="alt"
                                      title="about-v1-img2"
                                    />{" "}
                                  </div>
                                </li>

                                <li>
                                  <div class="img-box2">
                                    <img
                                      decoding="async"
                                      src="/images/mechanical9.png"
                                      alt="alt"
                                      title="about-v1-img3"
                                    />{" "}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-22202b9 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="22202b9"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-43aacfc"
            data-id="43aacfc"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-c9f8b7c elementor-widget elementor-widget-ontech-service"
                data-id="c9f8b7c"
                data-element_type="widget"
                data-widget_type="ontech-service.default"
              >
                <div class="elementor-widget-container">
                  <section class="services-one">
                    <div class="shape3">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape2.png"
                        alt=""
                      />
                    </div>
                    <div class="shape4">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape3.png"
                        alt="alt"
                      />
                    </div>
                    <div class="shape5">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape4.png"
                        alt=""
                      />
                    </div>
                    <div class="shape6">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape5.png"
                        alt="alt"
                      />
                    </div>
                    <div class="shape7">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape6.png"
                        alt="alt"
                      />
                    </div>
                    <div class="shape8">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape7.png"
                        alt=""
                      />
                    </div>
                    <div class="shape9">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape8.png"
                        alt="alt"
                      />
                    </div>
                    <div class="shape10">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape9.png"
                        alt=""
                      />
                    </div>
                    <div class="shape11">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape10.png"
                        alt=""
                      />
                    </div>
                    <div class="shape12">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape11.png"
                        alt=""
                      />
                    </div>

                    <div class="container">
                      <div class="services-one__top">
                        <div class="sec-title">
                          <div class="sec-title__tagline">
                            <div class="inner">
                              <div
                                class="round-box"
                                style={{ marginBottom: "1px" }}
                              >
                                <img
                                  decoding="async"
                                  src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/sec-title-shape.png"
                                  alt="alt"
                                  title="sec-title-shape"
                                />{" "}
                              </div>
                              <div class="text">
                                <p class="section-title__sub-title">
                                  Our Services
                                </p>
                              </div>
                            </div>
                          </div>
                          <h2 class="sec-title__title">
                            Providing Complete <br /> Professional Design
                            Services
                          </h2>
                        </div>

                        <div class="services-one__top-text">
                          <p class="summary" style={{ fontSize: "18px" }}>
                            Fusing creativity with functionality to engineer
                            design solutions that elevate user experiences to
                            new heights.
                          </p>
                        </div>
                      </div>

                      <div class="row hidden">
                        <div
                          class="col-xl-3 col-lg-6 col-md-6  wow fadeInLeft floating_icon"
                          data-wow-delay="0ms"
                          data-wow-duration="1000ms"
                        >
                          <div class="services-one__single text-center">
                            <div class="shape2">
                              <img
                                decoding="async"
                                src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape1.png"
                                alt="alt"
                                title="services-v1-shape1"
                              />
                            </div>
                            <div class="services-one__single-icon">
                              {/* <div class="shape1"></div> */}
                              {/* <span aria-hidden="true" class="  icon-server-data"></span>  */}

                              <GiMechanicGarage
                                style={{
                                  fontSize: "90px",
                                  color: "var(--ontech-base)",
                                }}
                              />
                              {/* <img src="./online-learning.png" style={{height: "90px"}}/> */}
                            </div>

                            <div class="services-one__single-content">
                              <h2>
                                <a class="" href="/Courses">
                                  Mechanical
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "18px" }}>
                                Design is the intentional process of creating
                                solutions that address specific needs or
                                problems.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-3 col-lg-6 col-md-6  wow fadeInLeft floating_icon"
                          data-wow-delay="0ms"
                          data-wow-duration="2000ms"
                        >
                          <div class="services-one__single text-center">
                            <div class="shape2">
                              <img
                                decoding="async"
                                src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape1.png"
                                alt="alt"
                                title="services-v1-shape1"
                              />{" "}
                            </div>
                            <div class="services-one__single-icon">
                              {/* <div class="shape1"></div> */}
                              {/* <span aria-hidden="true" class="   icon-laptop"></span> */}
                              {/* <img src="./online-learning.png" style={{height: "90px"}}/> */}
                              <FaBuildingUser
                                style={{
                                  fontSize: "90px",
                                  color: "var(--ontech-base)",
                                }}
                              />
                            </div>

                            <div class="services-one__single-content">
                              <h2>
                                <a class=" " href="/Courses">
                                  Civil
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "18px" }}>
                                Civil engineering involves designing and
                                constructing infrastructure like roads, bridges,
                                and buildings.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-3 col-lg-6 col-md-6  wow fadeInLeft floating_icon"
                          data-wow-delay="0ms"
                          data-wow-duration="3000ms"
                        >
                          <div class="services-one__single text-center">
                            <div class="shape2">
                              <img
                                decoding="async"
                                src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape1.png"
                                alt="alt"
                                title="services-v1-shape1"
                              />{" "}
                            </div>
                            <div class="services-one__single-icon">
                              {/* <div class="shape1"></div> */}
                              {/* <span aria-hidden="true" class="   icon-hard-drive"></span> */}

                              {/* <img src="./online-learning.png" style={{height: "90px"}}/> */}
                              <GiElectricalResistance
                                style={{
                                  fontSize: "90px",
                                  color: "var(--ontech-base)",
                                }}
                              />
                            </div>

                            <div class="services-one__single-content">
                              <h2>
                                <a class="  " href="/Courses">
                                  Electrical
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "18px" }}>
                                Electrical engineering focuses on
                                electricity,and systems, powering modern
                                technology and devices.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-3 col-lg-6 col-md-6  wow fadeInLeft floating_icon"
                          data-wow-delay="0ms"
                          data-wow-duration="4000ms"
                        >
                          <div class="services-one__single text-center">
                            <div class="shape2">
                              <img
                                decoding="async"
                                src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/services-v1-shape1.png"
                                alt="alt"
                                title="services-v1-shape1"
                              />{" "}
                            </div>
                            <div class="services-one__single-icon">
                              {/* <div class="shape1"></div> */}
                              {/* <span aria-hidden="true" class="   icon-marketing-analysis"></span> */}
                              {/* <img src="./online-learning.png" style={{height: "90px"}}/> */}
                              <RiComputerLine
                                style={{
                                  fontSize: "90px",
                                  color: "var(--ontech-base)",
                                }}
                              />
                            </div>

                            <div class="services-one__single-content">
                              <h2>
                                <a class="   " href="/Courses">
                                  Computer
                                </a>{" "}
                              </h2>
                              <p style={{ fontSize: "18px" }}>
                                Computer engineering hardware and
                                software developing computing systems and
                                technologies.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="services-one__bottom text-center hidden">
                        <h2 class="">We’re Ready To Grow Your Design Life</h2>
                        <p class="">
                          Our design philosophy revolves around a user-centric
                          approach, where every pixel and line serves a purpose
                          in enhancing the user experience.
                        </p>
                        <div class="btn-box">
                          <a class="thm-btn" href="/Courses">
                            More View
                          </a>{" "}
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-b42d1f3 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="b42d1f3"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d8b48e0"
            data-id="d8b48e0"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-48c968d elementor-widget elementor-widget-ontech-video"
                data-id="48c968d"
                data-element_type="widget"
                data-widget_type="ontech-video.default"
              >
                <div class="elementor-widget-container">
                  <section class="video-one hidden">
                    <div class="shape1">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/video-v1-shape1.png"
                        alt="alt"
                        title="video-v1-shape1"
                      />{" "}
                    </div>
                    <div class="shape2">
                      <img
                        decoding="async"
                        src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/video-v1-shape1-1.png"
                        alt="alt"
                        title="video-v1-shape1"
                      />{" "}
                    </div>
                    <div class="container" style={{ marginLeft: "79px",paddingLeft:"80px",paddingRight:"80px" }}>
                      <div class="video-one__inner">
                        <div class="shape3">
                          <img
                            decoding="async"
                            src="https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/video-v1-shape3.png"
                            alt="alt"
                            title="video-v1-shape3"
                          />{" "}
                        </div>
                        <div
                          class="video-one__bg"
                          style={{
                            backgroundImage:
                              "url(https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/video-v1-bg.jpg)",
                          }}
                        ></div>

                        <div class=" video-one__icon">
                         
                           
                           <Link to="/"><FaGooglePlay/></Link>
                          
                          <span class="border-animation border-1"></span>
                          <span class="border-animation border-2"></span>
                          <span class="border-animation border-3"></span>
                        </div>
                        <div class="title-box text-center">
                          <h2 class="">We Are Design Solution Specialists.</h2>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-a514440 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="a514440"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e2058ac"
            data-id="e2058ac"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-414316c elementor-widget elementor-widget-ontech-call-to-action"
                data-id="414316c"
                data-element_type="widget"
                data-widget_type="ontech-call-to-action.default"
              >
                <div class="elementor-widget-container">
                  <section class="cta-one">
                    <div class="container">
                      {/* <div class="cta-one__inner">
                                                <div class="cta-one__bg" style={{ backgroundImage: "url(https://bracketweb.com/ontechwp/wp-content/uploads/2023/07/cta-v1-bg.jpg)" }}>
                                                </div>
                                                <div class="cta-one__text">
                                                    <h2 class="cta-one__title">Design Services Customized For Your Agency</h2>
                                                </div>

                                                <div class="cta-one__btn">
                                                    <a class="" href="https://bracketweb.com/ontechwp/projects/">View All Protfolio</a> 
                                                    </div>
                                            </div> */}
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    
      <div className="khansar_button_responsive">
        <a
          href="https://search.google.com/local/writereview?placeid=ChIJHRYm8RmvHToRNuqZrjW9SZc"
          target="_blanck"
        >
          <p
            style={{
              color: "#FFb237",
              textAlign: "center",
              marginTop: "30px",
              marginRight: "30px",
              textDecoration: "underline",
              fontSize: "24px",
              
            }}
          >
            
            <div class="btn-box">
                          <a class="thm-btn" href="https://search.google.com/local/writereview?placeid=ChIJHRYm8RmvHToRNuqZrjW9SZc" target="_black">
                          
                          <b>Write Review</b>
                          </a>{" "}
                        </div>
          </p>
        </a>
        <a
          href="https://search.google.com/local/reviews?placeid=ChIJHRYm8RmvHToRNuqZrjW9SZc"
          target="_blanck"
        >
          <p
            style={{
              color: "#FFb237",
              textAlign: "center",
              marginTop: "30px",
              textDecoration: "underline",
              fontSize: "24px",
              
            }}
          >
            <div class="btn-box reponsive_readmore">
                          <a class="thm-btn" href="https://search.google.com/local/reviews?placeid=ChIJHRYm8RmvHToRNuqZrjW9SZc" target="_black" >
                          
                          <b>Read More</b>
                          </a>{" "}
                        </div>
          </p>
        </a>
      </div>

      <Review />

     
    </>
  );
};

export default Homeslider;
